<template>
    <div>
        <nav class="navbar-default navbar-static-side" role="navigation">
            <div class="nav-close">
                <i class="fa fa-times-circle"></i>
            </div>
            <div class="sidebar-collapse">
                <ul class="nav" id="side-menu" >
                    <li class="nav-header">
                        <div class="dropdown profile-element">
                            <img src="../../../public/images/adminLogo.png" >
                        </div>
                        <div class="logo-element">Easy</div>
                    </li>
                    <li>
                        <a href="javascript:void(0);">
                            <i class="fa fa-columns"></i>
                            <span class="nav-label">文章管理</span>
                            <span class="fa arrow"></span>
                        </a>
                        <ul class="nav nav-second-level">
                            <li>
                                <router-link to="/article">文章列表</router-link>
                            </li>
                            <li>
                                <router-link to="/category">文章类型</router-link>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
        </nav>
    </div>
</template>

<script>
  export default {
    name: 'PageHeader'
  }
</script>
